"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitOfferBoldSegments = splitOfferBoldSegments;
exports.stripOfferMarkdownBold = stripOfferMarkdownBold;
exports.normalizeOfferGeneratedText = normalizeOfferGeneratedText;
/** Χωρίζει μία γραμμή σε τμήματα bold / κανονικά. */
function splitOfferBoldSegments(line) {
    const segments = [];
    const re = /\*\*(.+?)\*\*/g;
    let last = 0;
    let match;
    while ((match = re.exec(line)) !== null) {
        if (match.index > last) {
            segments.push({ text: line.slice(last, match.index), bold: false });
        }
        segments.push({ text: match[1], bold: true });
        last = match.index + match[0].length;
    }
    if (last < line.length) {
        segments.push({ text: line.slice(last), bold: false });
    }
    if (segments.length === 0) {
        segments.push({ text: line, bold: false });
    }
    return segments;
}
/** Αφαιρεί `**` / `__` (κρατά το κείμενο, χωρίς σύμβολα έντονης). */
function stripOfferMarkdownBold(text) {
    let out = text.replace(/\*\*([\s\S]+?)\*\*/g, '$1');
    out = out.replace(/\*\*/g, '');
    out = out.replace(/__([\s\S]+?)__/g, '$1');
    out = out.replace(/__/g, '');
    return out;
}
/** Καθαρισμός AI κειμένου προσφοράς πριν αποθήκευση/εμφάνιση στο editor. */
function normalizeOfferGeneratedText(text) {
    let out = stripOfferMarkdownBold(text);
    out = out.replace(/^#{1,6}\s+/gm, '');
    return out.trim();
}
